import React, { Key } from 'react';
import { useNavigate } from 'react-router-dom'

import InputFactory from 'components/Form/Fields/InputFactory/InputFactory'
import { TFieldsType } from 'models/Form/FieldsModels'
import { AppFormFieldsProps, AppFormProps, ButtonSubmitFormProps } from './AppFormProps'
import Button, { AppButtonTypes } from 'components/Buttons/ButtonBase/Button'
import ButtonCancelApplication from 'components/Buttons/ButtonCancelApplication/ButtonCancelApplication'
import Summary from 'components/Summary/Summary'
import useIsMobile from 'common/hooks/useIsMobile'
import { Environment } from 'enviroment/AppSettings'
import ButtonPreviousStep from 'components/Buttons/ButtonPreviousStep/ButtonPreviousStep'
import useTextContents from 'common/hooks/useTextContents'

import './AppFormStyles.scss'
import './safari.css'


/**
 * Komponent renderujący wszystkie pola formularza, po uprzednim przefiltrowaniu oraz posortowaniu
 */
const AppFormFields = (props: AppFormFieldsProps): JSX.Element | null => {
   if(props.fields === undefined){
      console.error("Nie udana próba stworzenia formularza. Pusty obiekt pól")
      return null
   }
   else {
      return (
         <>
            {Object.values(props.fields)
               .filter((field: TFieldsType) => field.visible !== false)
               .sort((a: TFieldsType, b: TFieldsType) => {
                     if (a.order && b.order) {
                        return a.order < b.order ? -1 : 1
                     } 
                     else return 0
               })
               .map((field: TFieldsType) => {
                  return (<InputFactory key={field.name as Key} field={field} />)
               })
            }   
         </>
      )
   }
}

/**
 * Komponent obsługujący przycisk zatwierdzający daną stronę formularza
 */
const ButtonSubmitForm = (props: ButtonSubmitFormProps): JSX.Element => {
   return (
      <Button
         uiButtonType={AppButtonTypes.PRIMARY}
         buttonContent={props.subbmitButtonText} 
         type="submit" 
         form={props.formName} 
         id={Environment.formSubmitionButtonId}
         className='page-app-form-submit-button page-main-button-submission-button'
      />
   )
}

/**
 * Główny komponent formularza aplikacji, renderujący widok wraz z odpowiednimi polami, przyciskami i nagłówkami.
 */
const AppForm = (props: AppFormProps): JSX.Element => {
   const navigate = useNavigate()
   const isMobileDevice = useIsMobile()
   const appFormTextContents = useTextContents()
   const { form } = props
   
   return (
      <div className='page-form-outer-wrapper app-form-safari-only'>
      <form name={form.name} id={form.name} className='page-form-inner-wrapper' onSubmit={(e: React.SyntheticEvent) => props.handleSubmitButtonClick(e)}>
         <div className='page-form-header-wrapper'>
            <h1 className=''>{appFormTextContents(form.labelTextContentPath)}</h1>
            {form.descriptionTextContentPath && (<p className='page-form-description'>{appFormTextContents(form.descriptionTextContentPath)}</p>)}
         </div>
         <div className='page-form-inputs-outer-wrapper'>
            <AppFormFields fields={form.fields}/>
         </div>

         {props.children ?? null} {/* Jeśli przekazaliśmy jakieś dzieci do komponentu, wyświetlamy je pomiędzy formularzem a przyciskiem */}

         <ButtonSubmitForm formName={form.name} subbmitButtonText={appFormTextContents(form.subbmitButtonTextContentPath)}/>
         <ButtonPreviousStep canStepBack={form.canStepBack} previousStepUrlPath={form.previousStepUrlPath} navigate={navigate} />
         <ButtonCancelApplication />
      </form>
      {!isMobileDevice && <Summary isExtended={true} />}
      </div>
   )
}

export default AppForm